"use client";
import * as React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import clsx from "clsx";
import { AppOptionType, AppOptionTypeSchema } from "@/models";
import AppCheckbox from "./AppCheckbox";
import { Box, Typography } from "@mui/material";
import { forwardRef } from "react";
import AppChip from "./AppChip";
import AppFormControlLoading from "./form-control/AppFormControlLoading";
export type AppComboboxProps = Partial<
  AutocompleteProps<any, any, any, any>
> & {
  options: AppOptionType[];
  label?: string;
  textFieldProps?: TextFieldProps;
  isLoading?: boolean;
};
const AppCombobox = forwardRef(
  (
    {
      options,
      label,
      sx,
      className,
      textFieldProps,
      multiple,
      isLoading,
      size,
      ...rest
    }: AppComboboxProps,
    ref
  ) => {
    return (
      <>
        {isLoading && <AppFormControlLoading size={size} />}
        {!isLoading && (
          <Autocomplete
            size={size}
            multiple={multiple}
            fullWidth
            disablePortal
            options={options}
            loadingText="Đang tải..."
            noOptionsText="Không có dữ liệu"
            clearText="Xóa"
            closeText="Đóng"
            className={clsx("rounded-2 ", className)}
            classes={{}}
            sx={{
              backgroundColor: "#fff",
              // borderRadius: "8px",
              "&&Mui-expanded": {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              },
              "&&Mui-expanded .MuiOutlinedInput-notchedOutline": {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              },
              "&& .MuiInputBase-root": {
                paddingLeft: "4px",
                paddingTop: "10px",
                paddingBottom: "10px",
                fontSize: "14px",
                lineHeight: "18px",
              },
              "&& .MuiInputBase-root.MuiInputBase-sizeSmall": {
                paddingLeft: "4px",
                paddingTop: "6px",
                paddingBottom: "6px",
                fontSize: "14px",
                lineHeight: "18px",
              },
              ".MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled": {
                backgroundColor: "disabled.main",
              },
              ".MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                {
                  borderWidth: 0,
                },
              "&& .MuiInputLabel-root": {
                fontSize: "14px",
                lineHeight: "18px",
                padding: "0 4px",
                transform: "translate(8px, 6px) scale(1)",
              },
              "&& .MuiInputLabel-root.MuiInputLabel-shrink": {
                transform: "translate(8px, -9px) scale(0.75)",
              },
              "&& .MuiOutlinedInput-root  .MuiInputBase-input": {
                padding: "0px 4px",
                fontSize: "inherit",
                lineHeight: "20px",
                height: "20px",
              },
              "&& .MuiOutlinedInput-notchedOutline": {
                padding: "0 8px",
                border: "1px solid",
                // boxShadow: "0px 2px 4px 0px #0000000f",
                borderRadius: "4px",
                borderColor: "border.secondary",
              },
              ".MuiInputBase-root.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "error.main",
                },
              "& .MuiAutocomplete-endAdornment": {
                // top: "calc(50% - 12px)",
              },
              "&& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  border: "2px solid",
                  // boxShadow: "0px 2px 4px 0px #0000000f",
                  borderColor: "primary.main",
                },
              // "&& .MuiInputBase-root.Mui-focused .MuiAutocomplete-endAdornment":
              //   {
              //     borderColor: "primary.main",
              //   },
              "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
                border: "1px solid",
                // boxShadow: "0px 2px 4px 0px #0000000f",
                borderColor: "primary.main",
              },
              // "& .MuiInputBase-root:hover .MuiAutocomplete-endAdornment": {
              //   borderColor: "primary.main",
              // },
              "&& + .MuiAutocomplete-popper .MuiPaper-root .MuiAutocomplete-listbox":
                {
                  padding: 0,
                },
              "&& + .MuiAutocomplete-popper .MuiPaper-root": {
                borderBottomLeftRadius: "4px",
                borderBottomRightRadius: "4px",
                // boxShadow: "0px 2px 4px 0px #0000000f",
                border: "unset",
              },
              "&& + .MuiAutocomplete-popper .MuiAutocomplete-listbox .MuiAutocomplete-option":
                {
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "16px",
                  padding: "8px 12px",
                  border: "unset",
                },
              "&& + .MuiAutocomplete-popper .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused":
                {
                  backgroundColor: "var(--light)",
                  color: "var(--primary)",
                },
              "&& + .MuiAutocomplete-popper .MuiAutocomplete-noOptions": {
                textAlign: "left",
                padding: "8px 12px",
              },
              "&&.MuiAutocomplete-root.MuiAutocomplete-root .MuiInputLabel-root:not(.MuiInputLabel-shrink)":
                {
                  top: "5px",
                },
              // "& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment": {
              //   right: 0,
              //   top: 0,
              //   transform: "unset",
              //   width: "40px",
              //   height: "100%",
              //   display: "flex",
              //   alignItems: "center",
              //   justifyContent: "center",
              //   borderLeft: "1px solid",
              //   borderLeftColor: "border.secondary",
              // },
              ...sx,
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                inputRef={ref}
                label={label}
                InputLabelProps={
                  {
                    //  shrink: true, // Đặt shrink thành false để không thu nhỏ label khi trường nhập được focus
                    // focused: true,
                  }
                }
                {...textFieldProps}
              />
            )}
            getOptionLabel={(option) => {
              if (AppOptionTypeSchema.safeParse(option).success) {
                return (
                  options?.find((item) => item.value === option.value)?.label ??
                  ""
                );
              } else {
                return (
                  options?.find((item) => item.value === option)?.label ?? ""
                );
              }
              // if (!multiple) {
              //   return options?.find((item) => item.value === option)?.label ?? "";
              // } else {
              //   return options?.find((item) => item.value === option)?.label ?? "";
              // }
            }}
            isOptionEqualToValue={(option, value) => {
              if (AppOptionTypeSchema.safeParse(value).success) {
                // console.log("value is of type AppOptionType");
                return option.value === value.value;
              } else {
                // console.log("value is not of type AppOptionType");
                return option.value === value;
              }
              // if (multiple) {
              //   return option.value === value;
              // } else {
              //   return option.value === value;
              // }
            }}
            getOptionDisabled={(option) => Boolean(option?.disabled)}
            renderOption={multiple ? renderOptionMultiType : renderOption}
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option: AppOptionType, index) => (
                <AppChip
                  label={<>{option.label}</>}
                  {...getTagProps({ index })}
                  key={option.value}
                />
              ))
            }
            {...rest}
            value={rest?.value === "" ? null : rest?.value}
          />
        )}
      </>
    );
  }
);
AppCombobox.displayName = "AppCombobox";
export default React.memo(AppCombobox);
const renderOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: AppOptionType
) => {
  return (
    <li
      {...props}
      key={option.value}
      style={{
        ...(props.style || {}),
        opacity: option.disabled ? 0.5 : 1,
        pointerEvents: option.disabled ? "none" : props.style?.pointerEvents,
      }}
    >
      <>{option.label}</>
    </li>
  );
};

const renderOptionMultiType = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: AppOptionType,
  { selected }: { selected: boolean }
) => {
  return (
    <li
      {...props}
      key={option.value}
      style={{
        ...(props.style || {}),
        opacity: option.disabled ? 0.5 : 1,
        pointerEvents: option.disabled ? "none" : props.style?.pointerEvents,
      }}
    >
      <Box className="">
        <AppCheckbox
          className="mr-2"
          checked={selected}
          disabled={option.disabled}
          label={<>{option.label}</>}
        />
      </Box>
    </li>
  );
};
